import styled from "styled-components";

export const FooterComponent = styled.footer`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #eeeeee; 
  padding: 6px;
  color: #595959;
  `